import { Import16 } from 'ui/icons';

import { testIds } from '../../../constants';
import { useHtmlLoaderContext } from '../../../contexts/HtmlLoaderContext';
import { useTranslations } from '../../../hooks/useTranslations';
import { ToolbarButton } from './BaseInsertButton';

export const LoadHtmlButton = () => {
  const { t } = useTranslations();
  const { showFilePicker } = useHtmlLoaderContext();
  return (
    <ToolbarButton
      onClick={showFilePicker}
      testId={testIds.toolbarBtnLoadHtml}
      tooltip={t('tooltip.loadHtml')}
    >
      <Import16 />
      <span>{t('button.loadHtml')}</span>
    </ToolbarButton>
  );
};
